<template>
  <div class="d-inline">
    <template v-if="!$route.params.service_id">
      <b-button-group size="sm" class="d-inline mb-1">
        <b-dropdown
          size="sm"
          :id="'dropdown_footer'"
          class="ml-2"
        >
          <template #button-content>
            <b-icon icon="gear-wide-connected" scale="1.2"></b-icon>
          </template>
          <button
            v-if="selected.length > 0"
            class="btn dropdown-item"
            @click="openCreateTaskSidebar"
          >
            <b-icon icon="kanban" aria-hidden="true" class="mr-2"></b-icon>
            Создать задачу для выбранных
          </button>
          <template v-if="checkActionAllow('delete')">
            <b-dropdown-divider></b-dropdown-divider>
            <b-dropdown-item-button
              variant="danger"
              @click="deleteSelectedItems()"
            >
              <b-icon icon="trash-fill" aria-hidden="true" class="mr-2"></b-icon>
              Удалить выбранные (не работает пока)
            </b-dropdown-item-button>
          </template>
        </b-dropdown>
      </b-button-group>
    </template>

    <CreateTaskWidget
      :elementIds="selectedIds"
      :elementDBField="'order_id'"
      @openCreateTaskSidebar="openCreateTaskSidebar"
    />
  </div>
</template>

<script>
import { checkActionAllow } from '@/mixins';
import CreateTaskWidget from '@/components/task/CreateTaskWidget.vue';
import { openCreateTaskSidebar } from '@/mixins/openTasksSidebar';

export default {
  components: {
    CreateTaskWidget,
  },
  props: {
    actionAllows: {
      type: Array,
      default: () =>[],
    }, // Array of rules for action allows
    selected: {
      type: Array,
      required: true
    }, // Array of selected elements
  },
  mixins: [
    checkActionAllow,
    openCreateTaskSidebar,
  ],
  data() {
    return {
      selectedIds: [],
      createMassTasks: false
    };
  },
  watch: {
    'selected': {
      handler(arrOfElements) {
        this.selectedIds = arrOfElements.map(element => element.id)
      },
      immediate: true
    },
  },
  methods: {
    deleteSelectedItems() {
      // this.$emit('universalEmit', 'deleteSelectedItems');
      console.log('Доступно только админам, не реализован бэкенд');
    },
  },
};
</script>
